// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__pwshE","signupButton":"Pagination_signupButton__09l2L"};